export const ACTIONS_COLUMN_WIDTH = 52;

export const BORDER_SLACK = 2;

export const SELECT_COLUMN_ID = "__select";

export const MIN_RESIZED_COLUMN_WIDTH = 60;
